import React, { useState } from 'react';
import { Box, TextField, Button, CircularProgress } from '@mui/material';

interface ManualInputTabProps {
  isAdding: boolean;
  onAdd: (question: string, answer: string) => void;
}

const ManualInputTab: React.FC<ManualInputTabProps> = ({ isAdding, onAdd }) => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');

  const handleAdd = () => {
    if (question.trim() && answer.trim()) {
      onAdd(question.trim(), answer.trim());
      // Clear inputs after submission
      setQuestion('');
      setAnswer('');
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <TextField
        label="Question"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        size="small"
        sx={{ width: '40%' }}
        disabled={isAdding}
      />      <TextField
        label="Answer"
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
        size="small"
        sx={{ width: '40%' }}
        disabled={isAdding}
        multiline
        rows={10}
      />
      <Button 
        variant="contained" 
        onClick={handleAdd}
        disabled={isAdding || !question.trim() || !answer.trim()}
        startIcon={isAdding ? <CircularProgress size={20} color="inherit" /> : null}
      >
        {isAdding ? 'Adding...' : 'Add'}
      </Button>
    </Box>
  );
};

export default ManualInputTab;